import { z } from "zod";

export const outputLanguageSchema = z.enum(["en", "de", "fr", "es", "it", "pt", "nl", "pl", "sv", "da"]);
export type OutputLanguage = z.infer<typeof outputLanguageSchema>;

export const parsedRequirementsSchema = z.object({
  requiredSkills: z.array(z.string()),
  niceToHaveSkills: z.array(z.string()).optional(),
  experienceYears: z
    .union([z.number(), z.object({ min: z.number(), max: z.number() })])
    .optional(),
  education: z.array(z.string()).optional(),
  responsibilities: z.array(z.string()).optional(),
  industry: z.string().optional(),
  seniority: z.string().optional(),
  languageRequirements: z
    .array(z.object({ language: z.string(), level: z.string().optional() }))
    .optional(),
  detectedLanguage: z.string().optional(),
});

export const jobStatusSchema = z.enum([
  "saved",
  "applied",
  "interview",
  "rejected",
  "offer",
]);

export type ParsedRequirements = z.infer<typeof parsedRequirementsSchema>;
export type JobStatus = z.infer<typeof jobStatusSchema>;
